// src/modules/app-views/serviceOrders/pages/Init/components/tableColumns/customerColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function customerColumn(buildColumnProps, options = {}) {
  const {
    key = 'customerSnapshot',
    title = 'customer',
    dataIndex = ['customerSnapshot', 'name'],
    width,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    className: 'text-truncate',
    ...buildColumnProps('customerSnapshot.name', columnProps),
    render: (_, r) => {
      const name = r?.customerSnapshot?.name || r?.customerName || '—';
      return (
        <div className="d-flex" style={{ width }}>
          <span className="font-weight-semibold">{name}</span>
        </div>
      );
    },
  };
}

export default customerColumn;
